import React, { useState, useEffect, useContext } from "react";
import { Paper, Box, Button, Typography, Link } from "@mui/material";
import { MHidden, MuiDialog } from "../@material-extend";
import { Link as RouterLink } from "react-router-dom";

import LoginBanner from "../../image/login_banner.png";
import GooglePlay from "../../image/android-download-white.svg";
import AppStore from "../../image/app-store.png";
import AuthSocial from "./AuthSocial";
import LoginForm from "../authentication/login/LoginForm";
import RegisterForm from "../authentication/register/RegisterForm";
import Constant from "../../util/constants";
import { Context } from "../../context";
import HttpService from "../../services/HttpService";
import Token from "../../util/Token";
import { DomainText } from "../chargeMiles/DomainText";
import { useDomainConfig } from "../../hooks/useDomainConfig";

const { label, action, methods } = Constant;
const styles = {
  loginSection: {
    width: "80%",
  },
  link: {
    textAlign: "center",
    marginTop: "8px",
  },
  typographyh5: {
    mt: 2,
    mb: 1,
    fontWeight: 700,
    background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
};


export default function AuthPopup() {
  const {
    auth: { authenticated, setAuthenticated },
    user,
  } = useContext(Context);
  const [popUpState, setPopUpState] = useState({
    openPopup: !1,
    toggelForm: label.LOGIN,
  });
  const domainConfig = useDomainConfig();
  const handleEvents = (type) => () => {
    if (action.MODAL_CLOSE === type) {
      setPopUpState({
        ...popUpState,
        openPopup: !1,
      });
      setAuthenticated({
        ...authenticated,
        authPopup: !1,
      });
    }

    if (action.TOGGLE_BUTTON === type)
      setPopUpState({
        ...popUpState,
        toggelForm:
          popUpState.toggelForm === label.LOGIN ? label.REGISTER : label.LOGIN,
      });
  };
  const actionContent = (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: { xs: 'center', sm: 'space-between' }, 
      flexDirection: { xs: 'column', sm: 'row' },
      width: '100%', 
      py: 1.5,
      px: { xs: 2, sm: 3 },
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: 3,
      mt: 1,
      boxSizing: 'border-box'
    }}>
      <Typography 
        variant="body1" 
        sx={{ 
          fontWeight: 600, 
          color: '#fff',
          fontSize: { xs: '0.85rem', sm: '0.95rem' },
          textAlign: { xs: 'center', sm: 'left' },
          lineHeight: 1.5,
          mb: { xs: 1.5, sm: 0 },
        }}
      >
        App Available now on PlayStore and App Store
      </Typography>
      <Box className="cm-apps" sx={{ display: 'flex', flexDirection: 'row !important', flexWrap: 'nowrap', gap: { xs: 1.5, sm: 2 }, alignItems: 'center', justifyContent: 'center', marginTop: '0 !important' }}>
        <Box 
          component="a"
          href={domainConfig.appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: 'flex', alignItems: 'center', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-2px) !important' } }}
        >
          <img
            src={AppStore}
            alt="App Store"
            style={{ width: '120px', height: '36px', objectFit: 'fill', marginTop: '0 !important' }}
            loading="lazy"
          />
        </Box>
        <Box 
          component="a"
          href={domainConfig.playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: 'flex', alignItems: 'center', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-2px) !important' } }}
        >
          <img
            src={GooglePlay}
            alt="Google Play"
            style={{ width: '120px', height: '36px', objectFit: 'fill', marginTop: '0 !important' }}
            loading="lazy"
          />
        </Box>
      </Box>
    </Box>
  );
  useEffect(() => {
    setPopUpState({
      ...popUpState,
      openPopup: authenticated.authPopup,
    });
  }, [authenticated.authPopup]);

  useEffect(() => {
    if (authenticated.authElementType) {
      const userData = Token.parsedToken();
      const getUser = async (userId) => {
        const userRes = await HttpService(methods.GET_USER, {
          queryParameters: { userId },
        });
        user.setUserDetail(userRes.data);
      };

      if (userData && userData.success && userData.data) {
        const {
          data: { _id },
        } = userData;
        getUser(_id);
      }
    }
  }, [authenticated?.authElementType]);

  useEffect(() => {
    let popUpStatus = localStorage.getItem("v1_chargemiles_popup_status");
    let isExpired = popUpStatus && new Date() > new Date(popUpStatus);
    if (!popUpStatus || isExpired) {
      localStorage.setItem(
        "v1_chargemiles_popup_status",
        new Date().setHours(24)
      );
      setAuthenticated({
        ...authenticated,
        authPopup: !0,
      });
    }
  }, []);

  const [fsElement, setFsElement] = useState(null);
  useEffect(() => {
    const handleFullscreenChange = () => {
      setFsElement(document.fullscreenElement || document.webkitFullscreenElement || null);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <MuiDialog
      key={fsElement ? 'fs' : 'body'}
      container={fsElement || document.body}
      open={popUpState.openPopup}
      onClose={handleEvents(action.MODAL_CLOSE)}
      maxWidth="sm"
      fullWidth={true}
      actions={true}
      actionContent={actionContent}
      className="auth-popup"
    >
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Paper
          elevation={0}
          sx={styles.rightSection}
          className="popup-login-section"
        >
          <Typography variant="h5" sx={styles.typographyh5}>
            {popUpState.toggelForm === label.LOGIN ? 'Welcome Back' : 'Create Account'}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mt: 1, mb: 2 }}
          >
            {popUpState.toggelForm === label.LOGIN 
              ? 'Log in to your account to continue' 
              : 'Register for a new account'}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mb: 2 }}
          >
            {popUpState.toggelForm === label.LOGIN ? "By logging in," : "By registering,"} I agree to <DomainText />
            &nbsp;
            <Link
              component={RouterLink}
              to="/terms-of-services"
              underline="always"
              sx={{ color: "primary.main" }}
              onClick={handleEvents(action.MODAL_CLOSE)}
            >
              Terms of Service
            </Link>
            &nbsp;and&nbsp;
            <Link
              component={RouterLink}
              to="/privacy-policy"
              underline="always"
              sx={{ color: "primary.main" }}
              onClick={handleEvents(action.MODAL_CLOSE)}
            >
              Privacy Policy
            </Link>
            .
          </Typography>
          {popUpState.toggelForm === label.LOGIN && <LoginForm isPopup />}
          {popUpState.toggelForm === label.REGISTER && <RegisterForm />}
          
          <AuthSocial></AuthSocial>
          
          <Typography variant="body2" sx={{ textAlign: 'center', mt: 2 }}>
            {popUpState.toggelForm === label.LOGIN ? (
              <>
                Don't have an account?&nbsp;
                <Link
                  component="button"
                  variant="subtitle2"
                  onClick={handleEvents(action.TOGGLE_BUTTON)}
                  sx={{ color: 'primary.main', fontWeight: 600, cursor: 'pointer', verticalAlign: 'baseline' }}
                >
                  Register
                </Link>
              </>
            ) : (
              <>
                Already have an account?&nbsp;
                <Link
                  component="button"
                  variant="subtitle2"
                  onClick={handleEvents(action.TOGGLE_BUTTON)}
                  sx={{ color: 'primary.main', fontWeight: 600, cursor: 'pointer', verticalAlign: 'baseline' }}
                >
                  Login
                </Link>
              </>
            )}
          </Typography>
        </Paper>
      </Box>
    </MuiDialog>
  );
}
